// extracted by mini-css-extract-plugin
module.exports = {"titleColor":"LoginPage_titleColor__1Hgd4"};